import STORE from '../store';
import invalidateVisCache from './invalidateVisCache';

const updateDashboardGadget = async (
  id: string,
  gadget: DashboardGadget,
  accountId: string,
) => {
  await STORE.visualisations
    .getDashboardGadgetsRef({ accountId })
    .doc(id)
    .set(gadget);

  await invalidateVisCache({
    accountId,
    changes: { dashboardGadgets: [id] },
  });

  return id;
};

export default updateDashboardGadget;
